export default __webpack_public_path__ + "static/media/898.5872c4fb.png";